import { catalogScopeMatches, type CatalogScope } from 'src/shared/services/storage/catalogScope'

export class CatalogSyncAbortedError extends Error {
  constructor () {
    super('catalog sync aborted because org or tenant changed')
    this.name = 'CatalogSyncAbortedError'
  }
}

let runId = 0

export function catalogSyncRunId (): number {
  return runId
}

export function abortInFlightCatalogSync (): void {
  runId += 1
}

export function catalogRunIsCurrent (
  startedId: number,
  startedScope: CatalogScope | undefined,
  liveScope: CatalogScope | undefined,
): boolean {
  return startedId === catalogSyncRunId() && catalogScopeMatches(startedScope, liveScope)
}

export function throwIfCatalogRunStale (
  startedId: number,
  startedScope: CatalogScope | undefined,
  liveScope: CatalogScope | undefined,
): void {
  if (!catalogRunIsCurrent(startedId, startedScope, liveScope)) {
    throw new CatalogSyncAbortedError()
  }
}
